import {useContext, useEffect, useRef, useState} from "react"
import ReactPaginate from "react-paginate"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCopy, faTimesCircle, faXmark} from "@fortawesome/free-solid-svg-icons";
import {DownloadButton} from "../../../Common/Button";
import {CredentialsContext} from "../../../API/CredentialsContext";
import {Actions} from "../../../Reducer/reducer";
import Highlight from 'react-highlight'


const ApiResponse = ({apiState, closed, jsonType}) => {
    const ref = useRef()
    const {dispatch} = useContext(CredentialsContext)

    useEffect(() => {
        ref.current.showModal()
    }, [])

    const close = () => {
        ref.current?.close()
        closed()
    }
    const copyToClipboard = async () => {
        try {
            await navigator.clipboard.writeText(JSON.stringify(apiState?.jsonResponse, null, 2));
            dispatch({type: Actions.Notify, payload: "Copied to Clipboard"})
            close()
        } catch (error) {
            console.error(error.message);
        }
    }
    return (
        <dialog className={"data-dialog"} ref={ref} onClose={close} onCancel={close}>
            <div className="modal-content">
                <div className="modal-header d-flex justify-content-between">
                    <h1 className="modal-title fs-5" id="staticBackdropLabel">{jsonType} for {apiState?.requestId}</h1>
                    <button type="button" className="btn btn-outline-dark" onClick={close} aria-label="Close">
                        <FontAwesomeIcon icon={faXmark}/>
                    </button>
                </div>

                <div className="modal-body">
                    <Highlight className={'json'}>
                        {JSON.stringify(apiState?.jsonResponse, null, 2)}
                    </Highlight>
                </div>
                <div className="modal-footer">
                    <button type="button" className="btn btn-warning" onClick={close}>
                        <FontAwesomeIcon icon={faTimesCircle}/> Cancel
                    </button>
                    &nbsp;&nbsp;
                    <button type="submit" className="btn btn-success" onClick={copyToClipboard}>
                        <FontAwesomeIcon icon={faCopy}/> Copy
                    </button>
                </div>
            </div>
        </dialog>
    )
}
const Table = ({handleDownloadExcel, apiState, handleViewModal, searchType, ebn}) => {

    const PER_PAGE = 50
    const [currentPage, setCurrentPage] = useState(0)

    function handlePageClick({selected: selectedPage}) {
        setCurrentPage(selectedPage)
    }

    const offset = currentPage * PER_PAGE
    const pageCount = Math.ceil(apiState.apiResponse?.length / PER_PAGE)

    const [show, setShow] = useState(false)

    useEffect(() => {
        const b = apiState.jsonResponse.hasOwnProperty("status") || apiState.jsonResponse.hasOwnProperty("credentials")
        setShow(b)
    }, [apiState.requestId, apiState.jsonResponse])

    let paginate = apiState.apiResponse.length !== 0 && apiState.apiResponse.length > PER_PAGE ?
        <div className="my-2">
            <ReactPaginate
                previousLabel={"Previous"}
                nextLabel={"Next"}
                breakLabel={"..."}
                pageCount={pageCount}
                marginPagesDisplayed={2}
                pageRangeDisplayed={3}
                onPageChange={handlePageClick}
                containerClassName={"pagination  justify-content-center"}
                pageClassName={"page-item"}
                pageLinkClassName={"page-link"}
                previousClassName={"page-item"}
                previousLinkClassName={"page-link"}
                nextClassName={"page-item"}
                nextLinkClassName={"page-link"}
                breakClassName={"page-item"}
                breakLinkClassName={"page-link"}
                activeClassName={"active primary"}
            />
        </div> : null
    return (
        <>
            {paginate}
            <table className="table table-striped px-4 mb-5">
                <thead className="table-dark">
                <tr className="text-uppercase">
                    <th>SL.No</th>
                    <th>Request Id</th>
                    <th>Type</th>
                    <th>Time</th>
                    <th>Ewaybills</th>
                    <th>
                        <DownloadButton onClick={handleDownloadExcel}>Excel</DownloadButton>
                    </th>
                </tr>
                </thead>
                <tbody>
                {
                    apiState.apiResponse
                        .slice(offset, offset + PER_PAGE)
                        .map((item, index) => {

                            const date = new Date(item.requestTime)
                            const hours = date.getHours()
                            const minutes = date.getMinutes()
                            const formattedHours = String(hours).padStart(2, '0')
                            const formattedMinutes = String(minutes).padStart(2, '0')
                            const timeString = searchType === 'API'
                                ? `${formattedHours}:${formattedMinutes}`
                                : date.toLocaleString("en-IN")

                            const vehicleNo = item.misc.vehicleNo
                            const consolidatedEWB = item.misc.consolidatedEWB
                            const location = item.misc.location
                            const successCount = item.successCount
                            const failCount = item.failCount

                            return (
                                <tr key={index}>
                                    <td>{offset + index + 1}</td>
                                    <td>{item.requestId}</td>
                                    <td>
                                        <div className="list-group mt-2">
                                            <div className="list-group-item active"> {item.requestType}</div>
                                            {vehicleNo &&
                                                <div className="list-group-item">Vehicle No - {vehicleNo}</div>}
                                            {consolidatedEWB &&
                                                <li className="list-group-item">CEWB No - {consolidatedEWB}</li>}
                                            {location && <div className="list-group-item">Location - {location}</div>}
                                        </div>
                                    </td>
                                    <td>{timeString}</td>
                                    <td>
                                        <div className="d-flex">
                                            {
                                                successCount !== 0 &&
                                                <div className="p-1">
                                                    <span>Success</span>
                                                    <small
                                                        className="border bg-success p-1 rounded text-white fw-bold ms-1">
                                                        {successCount}
                                                    </small>
                                                </div>
                                            }
                                            {
                                                failCount !== 0 &&
                                                <div className="p-1">
                                                    <span>Failure</span>
                                                    <small
                                                        className="border bg-danger p-1 rounded text-white fw-bold ms-1">
                                                        {failCount}
                                                    </small>
                                                </div>
                                            }
                                        </div>

                                        <div style={{maxWidth: "30vw"}}>
                                            {
                                                item.failedEwaybills.map((item, index) => {
                                                    if (searchType === 'EBN' && item === ebn)
                                                        return <span key={index}
                                                                     className={"badge text-bg-warning me-1"}>{item}</span>
                                                    return <span key={index}
                                                                 className="badge text-bg-danger me-1">{item}</span>
                                                })
                                            }

                                            {
                                                item.ewaybills.map((item, index) => {
                                                    if (searchType === 'EBN' && item === ebn)
                                                        return <span key={index}
                                                                     className={"badge text-bg-primary me-1"}>{item}</span>
                                                    return <span key={index}
                                                                 className="badge text-bg-success me-1">{item}</span>

                                                })
                                            }
                                        </div>

                                    </td>
                                    <td>
                                        <DownloadButton
                                            type={"primary"}
                                            size={'sm'}
                                            onClick={() => handleViewModal({
                                                id: item.id,
                                                request_id: item.requestId,
                                                what: 'request'
                                            })}
                                        >
                                            Request
                                        </DownloadButton>
                                        &nbsp;
                                        <DownloadButton
                                            type={"secondary"}
                                            size={'sm'}
                                            onClick={() => handleViewModal({
                                                id: item.id,
                                                request_id: item.requestId,
                                                what: 'json'
                                            })}
                                        >
                                            Response
                                        </DownloadButton>
                                    </td>
                                </tr>
                            )
                        })
                }
                </tbody>
            </table>
            {paginate}
            {show && <ApiResponse apiState={apiState} jsonType={apiState.responseType} closed={() => setShow(false)}></ApiResponse>}
        </>
    )
}
export default Table